<h1 mat-dialog-title>
    Vendor Products with Pending FTP
</h1>
<div mat-dialog-content>
    <mat-label *ngIf="ftpProducts.length === 0">No Pending FTP Transfers</mat-label>
    <mat-form-field *ngIf="ftpProducts.length > 0">
        <mat-label>Select Products to Send</mat-label>
        <mat-select multiple (selectionChange)="setProduct($event)">
            <mat-option *ngFor="let product of ftpProducts" [value]="product.id">{{product.name}} ({{product.count}})</mat-option>
        </mat-select>
    </mat-form-field>
</div>
<div class="buttons" mat-dialog-actions>
    <button class="okbutton" [disabled]="selectedProducts.length === 0" mat-raised-button color="primary" (click)="onConfirm()">Initiate FTP</button>
    <button mat-button (click)="onDismiss()">Cancel</button>
</div>
